import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

import { HoverCard, IBasePicker, IBasePickerSuggestionsProps, IExpandingCardProps, IPersonaProps, IPickerItemProps, Label, mergeStyleSets, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, ValidationState, Shimmer, ShimmerElementsGroup, ShimmerElementType, DirectionalHint, ITag, IBasePickerProps, IInputProps } from '@fluentui/react';

import { IField, ILookupField , IContact, IUserField } from '../../../shared/interfaces';
import { Indici_FormMode, Search_QueryOperator } from '../../../shared/enums';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import contactsService from '../../../services/contacts.service';
import { useBoolean } from '@fluentui/react-hooks';
import axios, { CancelTokenSource } from 'axios';
import { toastRef } from '../../Layout/Layout';
import ContactInfo from '../../../sharedComponents/ContactInfo';
import ArxeiaLabel from '../ArxeiaLabel';
import usersService from '../../../services/users.service';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    },
    compactCard: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        padding: "0 20px"
    },
    expandedCard: {
        padding: '16px 24px 24px'
    },
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    callout: {
        padding: '8px',
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },

    address: {
        height: '20px'
    }
});


let cancelTokenSources = {};



export interface AutocompleteUserHandle {
}

export interface AutocompleteUserProps {
    formMode?: Indici_FormMode
    field: IField
    autofocus?: boolean,
    changed: (newField: IField) => void
    //onPaste: (ev: React.ClipboardEvent<HTMLInputElement>, newField: IField) => void
}
type Props = AutocompleteUserProps


const AutocompleteUser: React.ForwardRefRenderFunction<AutocompleteUserHandle, AutocompleteUserProps> = (props, ref) => {

    const peoplePickerRef = React.createRef<IBasePicker<IPersonaProps>>();


    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const [contactCard, setContactCard] = useState<any>();
    const [mostRecentlyContactsUsed, setMostRecentlyContactsUsed] = useState<any[]>([]);
    const [shimmerElementsVisible, { setTrue: showShimmerElements, setFalse: hideShimmerElements }] = useBoolean(false);

    useEffect(() => {
        // Anything in here is fired on component mount.


        return () => {
            // Anything in here is fired on component unmount.

            // cancello tutte le request in pending
            for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                value.cancel(`${key} canceled`)
            }

        }
    }, [])




    let userField = props.field as IUserField ;
    let userFieldBasePickerProps = userField.basePickerProps ? userField.basePickerProps as IBasePickerProps<IPersonaProps> : undefined;

    const personaSuggestionProps: IBasePickerSuggestionsProps = userFieldBasePickerProps?.pickerSuggestionsProps ??
    {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Utenti suggeriti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
        forceResolveText: "Cerca valore inserito",
        showForceResolve: props.formMode === Indici_FormMode.Search ? () => { return true } : () => { return false }
    };


    const inputChanged = (newField: IField) => {
        props.changed({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }

    //const inputPaste = (ev: React.ClipboardEvent<HTMLInputElement>) => {
    //    props.onPaste(ev, { ...contactsField })
    //}

    //const inputProps: IInputProps = { onPaste: inputPaste };


    let selectedPersonas: any[] = [];
    if (userField.internalValue)
        selectedPersonas = [...userField.internalValue];


    const createGenericItem = (input: string) => {
        let tag = { key: input, text: input, isGenericItem: true }
        return tag;
    }


    const onResolveSuggestions = userFieldBasePickerProps?.onResolveSuggestions === undefined
        ? async (filterText: string, currentPersonas?: IPersonaProps[]): Promise<IPersonaProps[]> => {
            if (currentAoo && filterText) {
                let filteredPersonas = await filterPersonasByText(filterText);

                if (currentPersonas)
                    filteredPersonas = removePeoplePickerDuplicates(filteredPersonas, currentPersonas);

                return filteredPersonas;
            } else {
                return [];
            }
        }
        : userFieldBasePickerProps.onResolveSuggestions;

    const filterPersonasByText = async (filterText: string): Promise<IPersonaProps[]> => {
        let personas: any[] = [];
        await usersService.getUserSuggestion(filterText)
            .then(suggestions => {
                suggestions.forEach(userField => {
                    personas.push(
                        {

                            key: userField.userPrincipalName,
                            imageUrl: userField.imageUrl,
                            imageInitials: userField.initials,
                            text: userField.displayName,
                            secondaryText: userField.userPrincipalName,
                            showSecondaryText: true,
                            hidePersonaDetails: false,
                            user: userField

                        }
                    );
                })
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                } else if (!error.isErrorShown) {
                    toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni`, life: 5000 });

                }

            });

;
        return personas;
    };
    const removePeoplePickerDuplicates = (personas: IPersonaProps[], possibleDupes: IPersonaProps[]) => {
        return personas.filter(persona => possibleDupes.findIndex(el => el.key === persona.key) < 0);
    }


    const onPersonaSelected = (selectedItem: any): IPersonaProps | null => {
        let recent = [...mostRecentlyContactsUsed];
        recent.push({ selectedItem });
        //assegno l'operatore contains solo alle ricerche fatte aggiungendo un item custom 
        // e l'operatore equals alle ricerche fatte attraverso i suggerimenti
        let { search_QueryOperator } = userField;

        if (selectedItem.isGenericItem) {
            search_QueryOperator = Search_QueryOperator.Contains;
        } else {
            search_QueryOperator = Search_QueryOperator.Equals;
        }
        props.field.search_QueryOperator = search_QueryOperator;
        // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
        // gli elementi selezionati tramite inputChanged(selectedItem) che setta l'internalValue del campo
        return selectedItem;
    }


    const onPersonaChange = (items?: any[]): void => {
        inputChanged({ ...userField, internalValue: items });
    };








    return (
        <div className={classNames.inputWrapper}>
            <div className={userField.touched && !userField.valid ? 'field error' : 'field'}>
                <ArxeiaLabel field={userField} />

                <NormalPeoplePicker
                    key={userField.internalName}
                    className={'ms-PeoplePicker'}
                    pickerSuggestionsProps={personaSuggestionProps}
                    getTextFromItem={getTextFromPersonaItem}
                    createGenericItem={userFieldBasePickerProps?.createGenericItem ?? createGenericItem}
                    selectionAriaLabel={'Selected contacts'}
                    removeButtonAriaLabel={'Remove'}
                    inputProps={userFieldBasePickerProps?.inputProps}
                    resolveDelay={300}
                    disabled={userField.readonly || userField.disabled}
                    selectedItems={selectedPersonas}
                    itemLimit={userField.multi && props.formMode !== Indici_FormMode.Search ? undefined : 1}
                    componentRef={peoplePickerRef}

                    // eslint-disable-next-line react/jsx-no-bind
                    onResolveSuggestions={onResolveSuggestions}
                    onInputChange={onPeoplePickerInputChange}
                    onValidateInput={userFieldBasePickerProps?.onValidateInput ?? validatePersonaInput}
                    onEmptyResolveSuggestions={userFieldBasePickerProps?.onEmptyResolveSuggestions}
                    onItemSelected={onPersonaSelected}
                    onChange={onPersonaChange}

                />
                {userField.touched && !userField.valid && <span className="error-message">Campo obbligatorio</span>}

            </div>
        </div>
    );


};


const ForwardedAutocompleteUser = React.forwardRef(AutocompleteUser);
export default ForwardedAutocompleteUser;






/**
 * Takes in the picker input and modifies it in whichever way
 * the caller wants, i.e. parsing entries copied from Outlook (sample
 * input: "Aaron Reid <aaron>").
 *
 * @param input The text entered into the picker.
 */
function onPeoplePickerInputChange(input: string): string {
    const outlookRegEx = /<.*>/g;
    const emailAddress = outlookRegEx.exec(input);

    if (emailAddress && emailAddress[0]) {
        return emailAddress[0].substring(1, emailAddress[0].length - 1);
    }

    return input;
}

function getTextFromPersonaItem(persona: any): string {
    return persona.contatto as string;
}


function validatePersonaInput(input: string): ValidationState {
    if (input.indexOf('@') !== -1) {
        return ValidationState.valid;
    } else if (input.length > 1) {
        return ValidationState.warning;
    } else {
        return ValidationState.invalid;
    }
}


